import { PRNG } from "./utils";

export default class DataStore {
  constructor(json = null) {
    this.assets = {};
    this.ocrs = {};
    this.ocrsList = [];
    this.gacLIst = [];

    this.tags = {};
    this.tagsScore = {};
    this.tagsList = [];

    this.categoriesList = [];
    this.categories = {};

    // this._svgList = [
    //   "./svg/1.svg",
    //   "./svg/2.svg",
    //   "./svg/3.svg",
    //   "./svg/3.svg",
    //   "./svg/4.svg",
    //   "./svg/5.svg",
    //   "./svg/6.svg",
    //   "./svg/7.svg",
    //   "./svg/8.svg",
    //   "./svg/9.svg",
    //   "./svg/10.svg",
    //   "./svg/11.svg",
    //   "./svg/12.svg",
    // ];

    this._svgList = [
      "./images/illustrations/1.png",
      "./images/illustrations/2.png",
      "./images/illustrations/4.png",
      "./images/illustrations/5.png",
      "./images/illustrations/6.png",
      "./images/illustrations/7.png",
      "./images/illustrations/8.png",
      "./images/illustrations/9.png",
      "./images/illustrations/10.png",
      "./images/illustrations/11.png",
      "./images/illustrations/12.png",
    ];

    if (json != null) this.parse(json);
  }

  get versoRecto() {
    return this._versoRecto;
  }
  //   LUT  = json/recto-verso.json
  set versoRecto(LUT) {
    this._versoRecto = LUT;
    // inverts the LUT to have a VERSO > RECTO table
    this._rectoVerso = {};
    for (let key in LUT) {
      this._rectoVerso[LUT[key]] = key;
    }
  }

  /**
   * builds revers LUT from the list of assets
   * @param {JSON is a dictionary of entries indexed by GACID} json
   */
  parse(json) {
    // an entry:
    //     item.ocr : the ocr text
    //     item.tag : the tags list
    //     item.cat : the list of categories this item belongs to

    /*
    "ZAHPJLpCg-Atgg": 
    {
        "ocr": "NATIONAL MARKET PRODUCE SHOW AT OLYMPIA.\nPhoto ", 
        "tag": ["london", "olympia", "art library", ... ],
        "cat": ["/Arts & Entertainment", "/Food & Drink"]}
    */

    Object.assign(this.assets, json);

    // store the categories
    for (let GAC_ID in json) {
      const obj = json[GAC_ID];

      // store the texts
      this.ocrs[GAC_ID] = obj.ocr;
      this.ocrsList.push(obj.ocr);
      this.gacLIst.push(GAC_ID);

      // tags dictionary : tags[ tagName ] = [ assets IDS... ]
      obj.tag.forEach((tag) => {
        // JS doesn't like this...
        if (tag == "constructor") return;
        if (tag == tag.toUpperCase()) return;

        // store the GAC_IDS list for this tag
        const key = tag.toLowerCase();
        if (this.tags[key] == undefined) {
          this.tags[key] = [];
        }

        this.tags[key].push(GAC_ID);
      });

      // categories dictionary : categories[ XXX ] = [ assets IDS... ]
      obj.cat.forEach((category) => {
        // store the category name
        if (this.categoriesList.indexOf(category) == -1) {
          this.categoriesList.push(category);
        }

        // store items list
        if (this.categories[category] === undefined) {
          this.categories[category] = [];
        }

        this.categories[category].push(GAC_ID);
      });
    }

    // compute the tags score

    // exclude these: > 700 results ( TODO remove completely from JSON? )
    this.exclude = [
      "photograph",
      "copyright photograph",
      "daily herald",
      "FIRST PUBLICATION MONDAY",
      "FIRST PUBLICATION TUESDAY",
      "FIRST PUBLICATION WEDNESDAY",
      "FIRST PUBLICATION THURSDAY",
      "FIRST PUBLICATION FRIDAY",
      "FIRST PUBLICATION SATURDAY",
      "FIRST PUBLICATION SUNDAY",
      "PHOTO SHOWS",
      "PHOTOGRAPH SHOWS",
      "One",
      "titled",
      "caption",
      "back",
      "reads",
    ].map((s) => s.toLowerCase());

    this.validTags = [];
    this.invalidTags = [];
    for (let tag in this.tags) {
      const count = this.tags[tag].length;
      if (
        this.exclude.indexOf(tag.toLowerCase()) === -1 &&
        tag != tag.toUpperCase()
      ) {
        // stroe the score
        const key = tag.toLowerCase();
        if (this.tagsScore[key] == undefined) {
          this.tagsScore[key] = 0;
        }
        this.tagsScore[key] += count;

        // store the tag name
        this.tagsList.push(tag);
      } else {
        this.invalidTags.push(tag);
        delete this.tags[tag];
      }
    }
    // console.log("=> taglist", this.tagsList.length);
  }

  /**
   * selects assets list by category
   * @param { int || string } categories
   *    either a categories count : N categories will be picked at random
   *    or a category name : IùmageCount assets will be picked from this category
   * @param {*} imagesCount number of images per category
   * @returns
   */
  getCategoriesContent(categories = 3, imagesCount = 10) {
    //is categories is a string, we need to scan only 1 category
    let categoriesCount = 1;
    // if categories is an number, we'll need 'categories' results
    const singleCategory = isNaN(categories);
    if (singleCategory == false) {
      categoriesCount = categories;
    }

    const imagesByCat = {};
    const randomCats = [];
    const versoIdsList = [];

    const tmpList = this.categoriesList.concat();

    // pick X random categories
    for (let i = 0; i < categoriesCount; i++) {
      //
      // choose random category
      let categoryName = categories; //ok if categories is a string

      if (singleCategory == false) {
        const rnd = ~~(PRNG.random() * tmpList.length);
        categoryName = tmpList.splice(rnd, 1)[0];
      }

      const category = this.categories[categoryName];

      // store the category name
      randomCats.push(categoryName);

      // result object
      imagesByCat[categoryName] = [];

      //   choose random ids from this category
      const tmpCategory = category.concat();

      for (let j = 0; j < Math.min(category.length, imagesCount); j++) {
        //
        // the index key is the GAC ID of the back of each image (verso)
        const rnd = ~~(PRNG.random() * tmpCategory.length);
        let verso = tmpCategory[rnd];
        tmpCategory.splice(rnd, 1);

        // populate result object and flat listflat
        imagesByCat[categoryName].push(verso);
        versoIdsList.push(verso);
      }
    }

    return { imagesByCat, versoIdsList };
  }

  // front and back of a GAC ID
  getAssetVerso(asset) {
    if (this._rectoVerso[asset] === undefined) return asset;
    return this._rectoVerso[asset];
  }
  getAssetRecto(asset) {
    if (this._versoRecto[asset] === undefined) return asset;
    return this._versoRecto[asset];
  }

  // asset text (OCR)
  getAssetText(asset) {
    return this.ocrs[asset].replace(/(?:\r\n|\r|\n)/g, "<br>");
  }

  // filtered asset tags list
  getAssetTags(asset) {
    // filter out invalid tags
    let tmp = this.assets[asset].tag.filter(
      (tag) => this.invalidTags.indexOf(tag) == -1 && tag != tag.toUpperCase()
    );

    //sort tags by score
    tmp.sort((a, b) => {
      return this.tagsScore[a.toLowerCase()] - this.tagsScore[b.toLowerCase()];
    });
    tmp.reverse();
    return tmp.map((tag) => tag);
  }

  getRandomSVG() {
    return fetch(this._svgList[~~(PRNG.random() * this._svgList.length)])
      .then((response) => response.text())
      .then((svg) => svg);
  }

  getRandomPNG() {
    return fetch(this._svgList[~~(PRNG.random() * this._svgList.length)])
      .then((response) => response.blob())
      .then((imageBlob) => `<img src="${URL.createObjectURL(imageBlob)}" />`);
  }
}

export const DATA_STORE = new DataStore();
